import React from "react";
import img from "../../assets/team/team9.png";

function Natalia() {
  return (
    <div className="bg-[#E8FCFF] w-full flex justify-center items-center py-11">
      <div className="max-w-[1440px] flex justify-between flex-col lg:flex-row items-center px-10 w-full gap-10">
        <div className="flex justify-center flex-col items-start gap-4">
          <h1 className="font-bold text-lightGreen-500 text-3xl md:text-5xl">
            Natalia Ploch-Bernier
          </h1>
          <h2 className="font-bold text-lightGreen-500 text-xl md:text-2xl">
            MSc. ABA, BCBA
          </h2>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Natalia is a psychologist and a Board Certified Behavior Analyst. She specialises in working with 
            children developmental disabilities. Her experience focuses mostly on early intervention and autism 
            spectrum disorder.
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Natalia graduated with triple Masters degree. She holds Masters in Psychology with a focus on 
            Applied Behavior Analysis from the California State University Stanislaus. She also holds a 
            Masters degree in Applied Behavior Analysis from the University of Bangor and a Masters in 
            Psychology from the University of Social Sciences and Humanities in Warsaw, Poland.
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Natalia has a keen interest in child psychology and child development.
          </p>
        </div>
        <img src={img} alt="" />
      </div>
    </div>
  );
}

export default Natalia;
